import React from "react";
import Page from "../../common/page/Page.js";
import useTranslationAdmin from "../useTranslationAdmin.js";
import AdminBlock from "./AdminBlock.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";


export default function AdminPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "AdminPage");

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="AdminPage">
          <Page.Title text={t("admin:admin_dashboard_title")} loading={tLoading} />
          <Page.Content>
            <AdminBlock />
          </Page.Content>
        </Page>
      )}
    />
  );
}
